
import { useState } from 'react';

export default function Gallery() {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState(0);

  const images = [
    {
      src: 'https://static.readdy.ai/image/c99dc7a7549e231b04ee549d68882537/aad1a3636eb6ea54bd7bccf742a47b57.jpeg',
      alt: '청주 아이폰수리 마켓 매장 외관',
      title: '매장 외관',
    },
    {
      src: 'https://static.readdy.ai/image/c99dc7a7549e231b04ee549d68882537/d106936715e48f2f02f9139a0c5f85c5.jpeg',
      alt: '청주 아이폰수리 마켓 매장 내부',
      title: '매장 내부',
    },
    {
      src: 'https://static.readdy.ai/image/c99dc7a7549e231b04ee549d68882537/d6a92e76c7248db4ca6c3e26cbd08a11.jpeg',
      alt: '청주 아이폰수리 마켓 매장 쇼윈도',
      title: '매장 쇼윈도',
    },
  ];

  const openLightbox = (index: number) => {
    setCurrentImage(index);
    setLightboxOpen(true);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
  };

  const goToPrevious = () => {
    setCurrentImage((currentImage === 0 ? images.length - 1 : currentImage - 1));
  };

  const goToNext = () => {
    setCurrentImage((currentImage === images.length - 1 ? 0 : currentImage + 1));
  };

  return (
    <section id="gallery" className="py-24 bg-[#FAFAFA]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-2 mb-6">
            <div className="w-2 h-2 bg-[#1a1a1a] rounded-full"></div>
            <span className="text-sm font-medium text-gray-600 uppercase tracking-wider">Gallery</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            매장 <span className="text-[#007AFF]">둘러보기</span>
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            청주 아이폰수리 마켓의 깔끔하고 전문적인 매장을 확인해보세요
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {images.map((image, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-2xl shadow-lg cursor-pointer transform transition-all duration-300 hover:scale-[1.02] hover:shadow-xl"
              onClick={() => openLightbox(index)}
            >
              <div className="w-full h-72 overflow-hidden">
                <img
                  src={image.src}
                  alt={image.alt}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <h3 className="text-white font-semibold text-lg">{image.title}</h3>
                </div>
              </div>
              <div className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center bg-white/90 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <i className="ri-zoom-in-line text-gray-800 text-xl"></i>
              </div>
            </div>
          ))}
        </div>
      </div>

      {lightboxOpen && (
        <div
          className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center"
          onClick={closeLightbox}
        >
          <button
            className="absolute top-6 right-6 w-12 h-12 flex items-center justify-center text-white hover:text-gray-300 transition-colors cursor-pointer"
            onClick={closeLightbox}
          >
            <i className="ri-close-line text-3xl"></i>
          </button>

          <button
            className="absolute left-6 top-1/2 -translate-y-1/2 w-12 h-12 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full text-white transition-colors cursor-pointer"
            onClick={(e) => {
              e.stopPropagation();
              goToPrevious();
            }}
          >
            <i className="ri-arrow-left-s-line text-2xl"></i>
          </button>

          <button
            className="absolute right-6 top-1/2 -translate-y-1/2 w-12 h-12 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full text-white transition-colors cursor-pointer"
            onClick={(e) => {
              e.stopPropagation();
              goToNext();
            }}
          >
            <i className="ri-arrow-right-s-line text-2xl"></i>
          </button>

          <div
            className="max-w-5xl max-h-[85vh] px-4"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={images[currentImage].src}
              alt={images[currentImage].alt}
              className="max-w-full max-h-[80vh] object-contain rounded-lg"
            />
            <div className="text-center mt-4">
              <h3 className="text-white font-semibold text-xl">{images[currentImage].title}</h3>
              <p className="text-gray-400 mt-1">{currentImage + 1} / {images.length}</p>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
